import { FC, useEffect } from 'react';
import { NavbarItem } from './NavbarItem';
import { ITabItem } from '@/common/models/INavbar';
import useNavbarStore from './useNavbarStore';

const list: ITabItem[] = [
  {
    name: 'land.plots',
    count: '0',
    type: 'LAND',
    id: '1',
  },
  {
    name: 'all.contours',
    count: '0',
    type: 'CONTOUR',
    id: '2',
  },
];
export const Navbar: FC = () => {
  const { count, countLoading, fetchNavbar } = useNavbarStore();
  useEffect(() => {
    fetchNavbar();
  }, []);
  return (
    <div className="flex items-center justify-center border-b py-[7px] h-[50px]">
      {countLoading ? (
        <div className="flex gap-6 py-1.5">
          <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
          <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
        </div>
      ) : (
        list.map((tab, index) => (
          <NavbarItem
            index={index}
            tab={tab}
            tabs={count}
            isLoading={countLoading}
            key={index}
          />
        ))
      )}
    </div>
  );
};
